import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../AuthProvider";

const navItems = [
  { to: "/fahrzeuge", label: "Fahrzeuge" },
  { to: "/fleet", label: "Fleet" },
  { to: "/fahrten", label: "Fahrten" },
  { to: "/kampagnen", label: "Kampagnen" },
  { to: "/rechnungen", label: "Rechnungen" },
  { to: "/platform", label: "Platform Einstellungen" },
  { to: "/kommunikation", label: "Kommunikation" },
];

export default function PortalSidebar() {
  const { logout } = useAuth();

  return (
    <aside className="portal-sidebar">
      <div className="portal-sidebar-top">
        <div className="portal-brand">WerbeAuto Admin</div>
        <nav className="portal-nav">
          {navItems.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => `portal-nav-link${isActive ? " active" : ""}`}
            >
              {label}
            </NavLink>
          ))}
        </nav>
      </div>
      <button className="portal-logout" onClick={() => logout()}>
        Logout
      </button>
    </aside>
  );
}
